import React from "react";
import { useQuery } from "react-query";
import RunnerBike from "./RunnerBike";

const Runner = () => {
  const { isLoading, data: bikes } = useQuery({
    queryKey: ["Bikes Suzuki"],
    queryFn: () =>
      fetch(
        "https://bike-resell-server-hasanalibd.vercel.app/bikes/Runner"
      ).then((res) => res.json()),
  });
  console.log(bikes);

  return (
    <div>
      {bikes?.map((bike) => (
        <RunnerBike key={bike._id} bike={bike}></RunnerBike>
      ))}
    </div>
  );
};

export default Runner;
